import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type { GlobalFilesOverview } from "../types/global-files-overview.types.ts"

const BASE_URL = "/project-management/global-files"

const PATHS = {
  overview: `${BASE_URL}/overview/`
}

// GET /project-management/global-files/overview/
export const getGlobalFilesOverview = async () => {
  return request.api.get<GlobalFilesOverview, BaseApiResponse<unknown>>(
    PATHS.overview
  )
}
